import jsBridge from './index'
/**
 * 返回指定的app主页面
 * @pageIndex
 *
0：返回首页
1：返回产品主页面
2：返回回放主页面
3：返回我的主页面

 */
export default function appBackMainPage(options = {}) {
  const { pageIndex = '' } = options
  return jsBridge('appointViewController', { pageIndex: pageIndex })
}
